export default __webpack_public_path__ + "static/payment-orchestration-5458a1e68e6f427911aedf23039ec5dc.png";